import { styled } from '@mui/material/styles'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded'
import { colorPalette } from '../../../view/style/colorPalette'
import { Text } from '../../../view/components/typography'
import { useLocation } from 'react-router-dom'
import { buildDemoInquiryUrl, DEMO_INQUIRY_LINK_LABEL } from './demoInquiry'

// デモ画面がすべての機能を備えていないことを、どの画面でもヘッダー中央で
// 常に伝えるための案内。DemoSupportSiteGuide（画面ごとの初期表示ダイアログ）
// とは役割が異なり、閉じる手段を持たない常設表示とする。
//
// 配色は製品のアクセント色（pink）。お知らせバナー（announcement-banner）と
// 同じ青系だと、ヘッダー自体が青系のアクセントを持つため案内が埋もれて
// 見落とされる。pinkは本体でも工数超過アラート等「見落とされては困る」
// 文脈に使われており、製品の配色から外れない。
// 文字サイズ・下線付きリンクの扱いはお知らせバナーと共有する。
//
// 表示文言はi18nを経由せずここに直接持つ。社外向けデモは日本語のみの想定で、
// この案内はデモ専用（本体の画面には出ない）ため、support-site-guide/と同じ方針。

// DemoSupportSiteGuide（初期表示ダイアログ）の末尾でも同じ断りを出すため、
// 文言はここから共有する。両者で表現がぶれないようにする意図。
export const DEMO_LIMITATION_MESSAGE = 'デモ画面のため機能に制限があります。'

// 画面タイトルのすぐ右に並べる。中央絶対配置をやめたことで、右側の
// アクション群の幅を実測して避ける必要がなくなり、通常のflexで収まる
// （狭い画面では文言側が省略される。NoticeText参照）。
const Container = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  height: '32px',
  marginLeft: '16px',
  padding: '0 14px',
  borderRadius: '16px',
  backgroundColor: colorPalette.pink[1],
  border: `1px solid ${colorPalette.pink[2]}`,
  minWidth: 0,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
})

const InfoIcon = styled(InfoOutlinedIcon)({
  fontSize: 16,
  color: colorPalette.pink[7],
  flexShrink: 0,
})

// 幅が足りない場合は、リンク（flexShrink: 0）ではなくこちらを省略して畳む。
// min-width: 0がないとflexアイテムは内容幅より縮まず、省略記号が出ないまま
// 親をはみ出す。
const NoticeText = styled(Text)({
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
})

// 区切り線。文言とリンクが地続きに読めてしまうのを防ぐ。
const Divider = styled('span')({
  flexShrink: 0,
  width: '1px',
  height: '14px',
  backgroundColor: colorPalette.pink[2],
})

const InquiryLink = styled('a')({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  flexShrink: 0,
  color: colorPalette.blue[8],
  textDecoration: 'underline',
  textUnderlineOffset: '2px',
  cursor: 'pointer',
  transition: 'opacity 0.2s',
  '&:hover': {
    opacity: 0.8,
  },
  // 矢印がわずかに進んで、クリックできることを伝える。
  '&:hover svg': {
    transform: 'translateX(2px)',
  },
})

const ArrowIcon = styled(ArrowForwardRoundedIcon)({
  fontSize: 14,
  transition: 'transform 0.2s',
})

export const DemoLimitationNotice = () => {
  const { pathname } = useLocation()

  return (
    <Container>
      <InfoIcon />
      <NoticeText variant="2sBold" color={colorPalette.pink[7]}>
        {DEMO_LIMITATION_MESSAGE}
      </NoticeText>
      <Divider />
      <InquiryLink
        href={buildDemoInquiryUrl(pathname)}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Text variant="2sMedium" color={colorPalette.blue[8]}>
          {DEMO_INQUIRY_LINK_LABEL}
        </Text>
        <ArrowIcon />
      </InquiryLink>
    </Container>
  )
}
